import React from 'react';
import { Box, Text } from '@bighealth/react-limbix-ui';

import Styled from './PortalShutdownPage.styles';

import BigHealthLogo from '../../../assets/BigHealthLogo.svg';

function PortalShutdownPage() {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      minHeight="100vh"
      padding="32px"
    >
      <Styled.Logo src={BigHealthLogo} alt="big-health-logo" />

      <Box
        maxWidth="480px"
        width="100%"
        padding="40px"
        border="1px solid #E2E6F4"
        borderRadius="12px"
        textAlign="center"
        boxShadow="0 2px 8px rgba(0, 0, 0, 0.05)"
        marginBottom="24px"
      >
        <Text fontSize="24px" lineHeight="32px" fontWeight="600" marginBottom="16px">
          The Spark Provider Portal is no longer supported
        </Text>
        <Text fontSize="16px">
          For help, please contact our support team
          <br />
          <strong>clinic@bighealth.com</strong>
        </Text>
      </Box>

      <Styled.BottomText>
        Use of the Provider Portal signifies acknowledgment of the&nbsp;
        <a
          href="https://privacy.bighealth.com/"
          target="_blank"
          rel="noreferrer"
        >
          Instructions for Use.
        </a>
      </Styled.BottomText>
    </Box>
  );
}

export default PortalShutdownPage;
